module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drone_update_modal.title":"ปรับค่า Drone","drone.field.latest_flight_time_sec.help":"ค่า Flight Time ของ Drone ปัจจุบัน","drone.field.firmware.help":"ค่า Firmware ปัจจุบัน","update.field.updated_date":"ข้อมูลวันที่","update.field.updated_date.help":"วันที่ได้ข้อมูลนี้มา","update.field.updated_time":"เวลา","update.field.updated_time.help":"เวลาโดยประมาณ"}}')
  delete Component.options._Ctor
}
